// extracted by mini-css-extract-plugin
module.exports = {"image":"BadgeImage__image___1OkSK","large":"BadgeImage__large___pRrtv","clickable":"BadgeImage__clickable___2RX-5"};